import client from './client';

export interface PackingBatchItem {
    item_id: number;
    item_name: string;
    source_grade: string;
    available_qty: number;
}

export interface PackingBatchReady {
    batch_id: number;
    batch_number: string;
    vendor_name: string;
    grn_number: string;
    grn_id: number;
    grading_date: string;
    items: PackingBatchItem[];
}

export interface PackingCreate {
    batch_id: number;
    item_id: number;
    source_grade: string;
    pack_size_kg: number;
    expected_packs: number;
    actual_packs: number;
    total_weight_packed: number;
    notes?: string;
}

export const packingApi = {
    getReadyBatches: async (): Promise<PackingBatchReady[]> => {
        const response = await client.get('/packing/ready');
        return response.data;
    },

    recordPacking: async (data: PackingCreate) => {
        const response = await client.post('/packing/record', data);
        return response.data;
    },

    finalizePacking: async (batchId: number) => {
        const response = await client.post(`/packing/finalize/${batchId}`);
        return response.data;
    },

    getHistory: async (batchId?: number): Promise<any[]> => {
        const response = await client.get('/packing/history', {
            params: { batch_id: batchId }
        });
        return response.data;
    },

    previewLabels: async (data: any) => {
        const response = await client.post('/packing/labels/preview', data);
        return response.data;
    }
};
